import React from "react";
import ReactDOM from "react-dom";

import "./styles.css";

function App() {
	return (
		<div className="App">
			<h1>Hello Developer 🔥🔥🔥</h1>
			<h2>Start editing to see some magic happen!😄🔥</h2>
			<h3>Hehehe! sorry, you can't 😅😎🔥🔥</h3>

			<h4>But you can edit this</h4>
		</div>
	);
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
